export default "__VITE_ASSET__ChKfZK4g__"